import { Instance } from 'mobx-state-tree';
import { CsvPreferencesDtoModelBase } from './CsvPreferencesDtoModel.base';

/* The TypeScript type of an instance of CsvPreferencesDtoModel */
export interface CsvPreferencesDtoModelType extends Instance<typeof CsvPreferencesDtoModel.Type> {}

/* A graphql query fragment builders for CsvPreferencesDtoModel */
export { selectFromCsvPreferencesDto, csvPreferencesDtoModelPrimitives, CsvPreferencesDtoModelSelector } from './CsvPreferencesDtoModel.base';

/**
 * CsvPreferencesDtoModel
 */
export const CsvPreferencesDtoModel = CsvPreferencesDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
